import { hcMapSlice } from './hcMap.slice';

export const MAP_REDUCER_KEY = 'map';

export const hcMapReducer = hcMapSlice.reducer;
